import _ from "lodash";

import { HIDE_DECIMAL } from "@/hooks/useConfig";
import { FormatCurrencyFunction } from "@/hooks/useConfig/types";

import { ComparisonMode } from "../types/comparisonMode";
import { GraphDataDTO } from "../types/dto";
import { calculateWeeklySpendDifference } from "./calculateWeeklySpendDifference";

export const getTitle = (curve: GraphDataDTO, comparisonMode: ComparisonMode) => {
  const [productName, ..._] = curve.nodeNames;
  switch (comparisonMode) {
    case ComparisonMode.CHANNEL:
      return curve.channelLabel || "";
    case ComparisonMode.BRAND:
    case ComparisonMode.CATEGORY:
    case ComparisonMode.PRODUCT:
      return productName || "";
    case ComparisonMode.GEOGRAPHY:
      return curve.geography || "";
    default:
      return undefined;
  }
};

export const getSubTitle = (curve: GraphDataDTO, comparisonMode: ComparisonMode) => {
  const [_, ...nodeNames] = curve.nodeNames;
  const combinedNames = nodeNames.join(" | ");
  if (
    comparisonMode === ComparisonMode.BRAND ||
    comparisonMode === ComparisonMode.CATEGORY ||
    comparisonMode === ComparisonMode.PRODUCT
  ) {
    return combinedNames;
  }
  return undefined;
};

export const getCurveDescription = (
  curve: GraphDataDTO,
  formatCurrency: FormatCurrencyFunction
) => {
  const weeklySpend = curve.spend / curve.activeWeeks;
  const weeklySpendDifference = calculateWeeklySpendDifference(weeklySpend, curve.maxEfficiency);
  return `by ${formatCurrency(weeklySpendDifference, HIDE_DECIMAL)}/week`;
};
